import ReactGA from "react-ga4";
import { GoogleAnalyticSubmissionEventPayload } from "../Interface";

class GoogleAnalyticService {
  private googleAnalyticMeasurementId: string;
  constructor() {
    this.googleAnalyticMeasurementId =
      process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID || "";
    ReactGA.initialize(this.googleAnalyticMeasurementId);
  }

  handleSubmissionEvents(data: GoogleAnalyticSubmissionEventPayload) {
    const { category, action, label } = data;
    try {
      ReactGA.event({
        category,
        action,
        label,
      });
    } catch (error: any) {
      console.error(
        "GoogleAnalyticService -> handleSubmissionEvents -> error",
        error
      );
    }
  }
}

const googleAnalyticService = new GoogleAnalyticService();
export default googleAnalyticService;
